export const RNShortDescription = () => {
    return (
        <>
            <div className="pt-3 pb-2">
                <p className="d-flex justify-content-center text-primary text-justify special-elite-regular">
                    In 2024 I had the honour of joining a study into gender bias
                    in the music industry. The following are the resulting 30
                    second tracks that I produced for the study. Click the
                    information buttons if you wish to know more.
                </p>
            </div>
        </>
    );
};
